export const CONFIG = {
  errorMessages: {
    required: 'Dieses Feld ist erforderlich.',
    requiredCheckbox: 'Dieses Feld ist erforderlich.',
    validEmail: 'Bitte eine gültige E-Mail-Adresse eingeben.',
    minlength: 'Bitte mindestens 6 Zeichen eingeben.',
    validCardDate: 'Ungültiges Ablaufdatum',
    validCardNumber: 'Ungültige Kreditkartennummer',
    validCardCvc: 'Ungültige Karte CVC'
  },
  errorOrdering: [
    'required',
    'requiredCheckbox',
    'minlength',
    'validEmail',
    'validEquals'
  ]
};



// WEBPACK FOOTER //
// ./src/app/form/input/input.config.ts